import React, { Component } from 'react';
import { HashRouter, Route, Switch, Link, Prompt } from 'react-router-dom';
import { Layout, Menu } from 'antd';

import homeTodayRecommend from '../page/homeTodayRecommend';
import caseHomeRecommend from '../page/caseHomeRecommend';
import caseHomeCarousel from '../page/caseHomeCarousel';
import popularadmin from '../page/popularAdmin';
import CaseCover from '../page/caseCover';
import CaseBehanceCrawling from '../page/caseBehanceCrawling';
import CaseDataManager from '../page/caseDataManager';
import ClassifyManage from '../page/classifyManage';
import LinkUrlManage from '../page/linkUrlManage';
import ExtensionWordsManage from '../page/extensionWordsManage';
import ClassifyCheck from '../page/classifyCheck';
import Editor from '../page/editor';
import searchCarouselKeys from '../page/searchCarouselKeys';
import homeSearchRecommendCase from '../page/homeSearchRecommendCase';
import DesingerChannelManager from '../page/desingerChannelManager';
import QuickShenhe from '../page/quickShenhe';
import QuickShenheDetail from '../page/quickShenheDetail';
import CaseQuickShenhe from '../page/caseQuickShenhe'
import CaseQuickShenheDetail from '../page/caseQuickShenheDetail';
import CaseCheck from '../page/caseCheck';

const { Content, Sider } = Layout
const SubMenu = Menu.SubMenu
export default class Case extends Component {
  state = {
    permissions: localStorage.getItem('permissions') && localStorage.getItem('systemType') === 'case',
    collapsed: false,
    contentLeft: 200, //内容距离左侧距离
    isChanged: localStorage.getItem('isChanged') && localStorage.getItem('isChanged') === '1'
  }

  onCollapse = (collapsed) => {
    this.setState({
      contentLeft: collapsed ? 80 : 200,
      collapsed,
    })
  }

  logout = () => {
    localStorage.removeItem('username')
    localStorage.removeItem('password')
    localStorage.removeItem('permissions')
    window.location.href = '/'
  }

  render() {
    const { contentLeft, permissions, isChanged } = this.state
    return (
      <HashRouter basename={window.__POWERED_BY_QIANKUN__ ? '/manager-linggan' : '/'}>
        {/* <LoginStatus systemType='linggan' /> */}
        <Layout>
          <Sider
            style={{
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
              left: 0,
            }}
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
          >
            <div className='logo'>
              <img width={120} src="https://znztv-image.oss-cn-shanghai.aliyuncs.com/userFace/logo_w.png" alt='' />
              <span style={{ color: '#fff', cursor: 'pointer', position: 'absolute', left: 20, top: 50 }} onClick={this.logout}>注销</span>
            </div>
            <Menu theme={'dark'} mode={'inline'}>
              <SubMenu title='案例管理'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/caseCheck'}>
                      案例审核
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/hometodayrecommend'}>
                      首页今日推荐
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/casehomerecommend'}>
                      案例首页推荐
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/casehomecarousel'}>
                      案例频道轮播
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/popularadmin'}>
                      案例首页POPULAR区
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/caseCover'}>
                      案例封面图
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/caseBehanceCrawling'}>
                      人工爬取behance需求
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/caseDataManager'}>
                      案例下架管理
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/classifyManage'}>
                      分类管理
                    </Link>
                  </Menu.Item>
                ) : null}
                {/* {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/classifyCheck'}>
                      分类审核
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  //
                  //
                  // <Prompt when={isChanged ? true : false} message="1231415"></Prompt>
                  <Menu.Item>
                    <Link to={'/case/editor'}>
                      案例正文编辑
                    </Link>

                  </Menu.Item>

                ) : null} */}
              </SubMenu>
              <SubMenu title='搜索管理'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/searchCarouselKeys'}>
                      搜索轮播词管理
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/homeSearchRecommendCase'}>
                      为您推荐管理
                    </Link>
                  </Menu.Item>
                ) : null}

              </SubMenu>
              <SubMenu title='频道页管理'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/desingerChannelManager'}>
                      设计师频道管理
                    </Link>
                  </Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu title='快速审核'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/quickShenhe'}>
                      快速分类审核
                    </Link>
                  </Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu title='案例快速审核'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/caseQuickShenhe'}>
                      快速分类审核
                    </Link>
                  </Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu title='SEO管理'>
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/linkUrlManage'}>
                    友情链接管理
                    </Link>
                  </Menu.Item>
                ) : null}
                {permissions ? (
                  <Menu.Item>
                    <Link to={'/case/extensionWordsManage'}>
                      拓词管理
                    </Link>
                  </Menu.Item>
                ) : null}
              </SubMenu>
            </Menu>
          </Sider>
          <Layout style={{ marginLeft: contentLeft }}>
            <Content style={{ margin: '10px 16px 0', overflow: 'initial' }}>
              <Switch>
                {permissions ? (
                  <>
                    <Route
                      exact
                      path='/case/caseDataManager'
                      component={CaseDataManager}
                    />
                    <Route
                      exact
                      path='/case/classifyManage'
                      component={ClassifyManage}
                    />
                    {/* <Route
                      exact
                      path='/case/classifyCheck'
                      component={ClassifyCheck}
                    />

                    <Route
                      exact
                      path='/case/editor'
                      component={Editor}
                    /> */}
                     <Route
                      exact
                      path='/case/linkUrlManage'
                      component={LinkUrlManage}
                    />
                    <Route
                      exact
                      path='/case/extensionWordsManage'
                      component={ExtensionWordsManage}
                    />
                    <Route
                      exact
                      path='/case/hometodayrecommend'
                      component={homeTodayRecommend}
                    />
                    <Route
                      exact
                      path='/case/casehomerecommend'
                      component={caseHomeRecommend}
                    />
                    <Route
                      exact
                      path='/case/casehomecarousel'
                      component={caseHomeCarousel}
                    />
                    <Route
                      exact
                      path='/case/popularadmin'
                      component={popularadmin}
                    />
                    <Route
                      exact
                      path='/case/caseCover'
                      component={CaseCover}
                    />
                    <Route
                      exact
                      path='/case/caseBehanceCrawling'
                      component={CaseBehanceCrawling}
                    />
                    <Route
                      exact
                      path='/case/searchCarouselKeys'
                      component={searchCarouselKeys}
                    />
                    <Route
                      exact
                      path='/case/homeSearchRecommendCase'
                      component={homeSearchRecommendCase}
                    />
                    <Route
                      exact
                      path='/case/desingerChannelManager'
                      component={DesingerChannelManager}
                    />
                    <Route
                      exact
                      path='/case/quickShenhe'
                      component={QuickShenhe}
                    />
                    <Route
                      exact
                      path='/case/caseQuickShenhe'
                      component={CaseQuickShenhe}
                    />
                    <Route
                      exact
                      path='/case/quickShenheDetail/:classifyId'
                      component={QuickShenheDetail}
                    />
                    <Route
                      exact
                      path='/case/caseQuickShenheDetail/:classifyId'
                      component={CaseQuickShenheDetail}
                    />
                    <Route
                        exact
                        path='/case/caseCheck'
                        component={CaseCheck}
                    />
                  </>
                ) : null}
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </HashRouter >
    )
  }
}
